/* Josenart 2.0 — 全站基础 JS（归属 A）。section 私有脚本放各自文件。 */
(function () {
  // 进场：首屏内元素静止可见，其余滚入视口时抬起
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.remove('is-pending');
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.jn-reveal').forEach(function (el) {
    if (el.getBoundingClientRect().top > window.innerHeight) {
      el.classList.add('is-pending');
      io.observe(el);
    }
  });

  // 全站事件约定（B 的 header / cart-drawer 监听这些）：
  //   cart:open           打开购物车抽屉
  //   cart:add  {detail:{id, quantity, properties}}  加购（cart.js 实现，成功后自己触发 cart:updated 并打开抽屉）
  //   cart:updated {detail:{cart}}  购物车变化后广播，header 角标据此刷新
  window.JN = window.JN || {};
  window.JN.emit = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  };

  // 2026-09-27 J4-mobile-12（移植 XP 现役 base.js checkChat，ZO d9482b1 / 53e6c1b 同款）：
  // Shopify Inbox 的启动器 fixed 在右侧，手机上会压住加购、Buy it now、优惠码 Apply、/cart 的 Remove 和 Checkout。
  // ① 启动器压到购物控件时（elementsFromPoint 命中 actions）整个隐藏：body.jn-chat-overlaps-action；
  // ② 底部吸附条（PDP 吸附加购条、/cart 吸底结账栏，或任何带 data-chat-avoid 的 fixed 底栏）出现、且会被启动器压到时，
  //    只把启动器上移到栏上方 12px（--jn-chat-lift + body.jn-chat-lifted）。JO 启动器离底约 120px，平时不用动；
  // ③ Inbox 的透明外框 .activator-nudge 没有 part 属性、主题 CSS 选不中，启动器被隐藏/上移后它还留在原位吃点击，
  //    这里在 shadowRoot 里直接关掉它的点击（不能只隐藏 ::part(activator)，否则留下透明死区）。
  // 样式在 snippets/jn-fix-content-css.liquid。只在 ≤959px 生效，桌面不动。
  var phone = window.matchMedia('(max-width: 959px)');
  var chatFrame = 0;
  var chatHost = null;
  var chatRoot = null;
  var chatLift = 0;
  var chatParts = new MutationObserver(queueChatCheck);
  // 和 XP 的差别：XP 把 main p / h2 / h3、整张商品卡片、主图都算进来，JO 启动器在右侧，这样在集合页 22 个滚动位置里
  // 只有 1 个能看到聊天入口。这里只避让真正要点的东西：按钮/输入/购买区/价格/购物车行/小链接；
  // 高度 > 96px 的整块链接（商品卡片、整图链接）盖住一角不影响点击，不触发隐藏（见 isAction）。
  var actions = 'a[href], button, input, select, textarea, summary, label, [role="button"]'
    + ', .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart'
    + ', .jn-pdp__title, .jn-pdp__price, .jn-pdp__buyrow, .jn-offer, .jn-qty, .jn-size, .jn-pdp__thumb'
    + ', .jn-bundle__row, .jn-bundle__foot'
    + ', .jn-cart-item__media, .jn-cart-item__title, .jn-cart-item__remove, .jn-cart-item__price, .jn-cart-item__qty'
    + ', .jn-cart-summary__totals, .jn-cart-summary__codes, .jn-cart-summary__checkout-form, .jn-cart-summary__express'
    + ', .jn-cart-page__bar, .jn-cart-bar, .jn-footer__payments'
    // integrate 0927：cart 组给购物车里要点的东西（商品行、码表单/标签、结账表单、View cart、备注、吸底栏）都打了 data-chat-avoid
    + ', [data-chat-avoid]';
  var bigLinkOk = '.jn-cart-item__media, .jn-cart-page__bar, .jn-cart-bar';
  function isAction(el) {
    var hit = el.closest(actions);
    if (!hit) return false;
    if (hit.matches('a[href]') && !hit.matches(bigLinkOk) && hit.getBoundingClientRect().height > 96) return false;
    return true;
  }
  // 底部 fixed 栏：出现时启动器让到它上面（cart / pdp 组的新栏用这些类名或加 data-chat-avoid 即可接入）
  var bars = '.jn-pdp__bar.is-show, .jn-cart-page__bar, .jn-cart-bar, [data-chat-avoid]';
  function setChatLift(px) {
    if (px === chatLift) return;
    chatLift = px;
    var body = document.body;
    if (px > 0) {
      document.documentElement.style.setProperty('--jn-chat-lift', px + 'px');
      body.classList.add('jn-chat-lifted');
    } else {
      document.documentElement.style.removeProperty('--jn-chat-lift');
      body.classList.remove('jn-chat-lifted');
    }
  }
  function checkChat() {
    chatFrame = 0;
    var overlaps = false;
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    if (host !== chatHost || root !== chatRoot) {
      chatParts.disconnect();
      chatHost = host;
      chatRoot = root;
      if (root) chatParts.observe(root, { childList: true, subtree: true });
    }
    var launcher = root && root.querySelector('[part~="activator"]');
    var lift = 0;
    // R6 replayfix 0930b JO：桌面 1440 也会压住商品页 Add to cart / PayPal 右端和 /cart 结账区（体检 F1），避让不再只限手机
    if (launcher) {
      var rect = launcher.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        // 启动器原位的底边 = 现在的底边 + 已经上移的量
        var baseBottom = rect.bottom + chatLift;
        var barTop = Infinity;
        Array.prototype.forEach.call(document.querySelectorAll(bars), function (el) {
          var r = el.getBoundingClientRect();
          if (!(r.height > 0 && r.top < window.innerHeight - 4 && r.bottom > window.innerHeight - 4)) return;
          // integrate 0927：data-chat-avoid 也打在购物车行、结账表单这些普通流元素上，它们跨过视口底边时不是"底栏"，
          // 只认 fixed / sticky 的栏，否则启动器会被抬到整张结账表单的顶上
          var cs = getComputedStyle(el);
          if ((cs.position === 'fixed' || cs.position === 'sticky') && cs.visibility !== 'hidden') {
            barTop = Math.min(barTop, r.top);
          }
        });
        if (barTop < Infinity && baseBottom > barTop - 8) lift = Math.ceil(baseBottom - barTop + 12);
        if (document.elementsFromPoint && lift === chatLift) {
          // 命中测试比逐个测量卡片便宜；被隐藏的启动器仍保留盒子，结果稳定
          var fractions = [0.04, 0.5, 0.96];
          overlaps = fractions.some(function (fx) {
            return fractions.some(function (fy) {
              return document.elementsFromPoint(rect.left + rect.width * fx, rect.top + rect.height * fy).some(function (el) {
                return el !== host && !host.contains(el) && isAction(el);
              });
            });
          });
        }
      }
    }
    setChatLift(lift);
    document.body.classList.toggle('jn-chat-overlaps-action', overlaps);
    if (root) {
      var narrow = true; // R6 replayfix 0930b JO：桌面同样处理外框点击
      var drawerOpen = !!document.querySelector('.jn-cart-drawer__dialog[open]');
      var hideNudge = narrow && (overlaps || lift > 0 || drawerOpen || document.body.classList.contains('jn-cart-checkout-visible'));
      Array.prototype.forEach.call(root.querySelectorAll('.activator-nudge'), function (nudge) {
        nudge.style.visibility = narrow && (overlaps || drawerOpen) ? 'hidden' : '';
        nudge.style.pointerEvents = hideNudge ? 'none' : '';
      });
      // 外框关掉点击后，启动器本身没被隐藏时要显式恢复可点（pointer-events 会继承）
      if (launcher) launcher.style.pointerEvents = hideNudge && !overlaps && !drawerOpen ? 'auto' : '';
    }
  }
  function queueChatCheck() {
    if (!chatFrame) chatFrame = window.requestAnimationFrame(checkChat);
  }
  window.addEventListener('scroll', queueChatCheck, { passive: true });
  window.addEventListener('resize', queueChatCheck, { passive: true });
  document.addEventListener('load', queueChatCheck, true);
  document.addEventListener('cart:updated', queueChatCheck);
  document.addEventListener('shopify:section:load', queueChatCheck);
  document.addEventListener('transitionend', queueChatCheck, true);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queueChatCheck, { passive: true });
    window.visualViewport.addEventListener('scroll', queueChatCheck, { passive: true });
  }
  if (phone.addEventListener) phone.addEventListener('change', queueChatCheck);
  new MutationObserver(queueChatCheck).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'hidden'] });
  if (document.fonts) document.fonts.ready.then(queueChatCheck);
  // Inbox 可能在 host 插入之后才挂 shadow tree（竖屏要等第一次触摸/滚动才加载）
  window.addEventListener('load', queueChatCheck);
  if (window.customElements) window.customElements.whenDefined('shopify-chat').then(queueChatCheck);
  queueChatCheck();
})();
